/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_View_DetailsInputs */

const fr_changelog_view_details = /** @type {(inputs: Changelog_View_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les détails`)
};

/**

* @param {Changelog_View_DetailsInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const changelog_view_details = /** @type {((inputs?: Changelog_View_DetailsInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_View_DetailsInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_changelog_view_details(inputs)
});